export default {
    init() {
        $('body').on('click', '[data-calories]', function(e) {

            // :---- Style
            if ($(this).hasClass('option-style')) {
                $('.option-style').removeClass('nutrition-selected');
                $(this).addClass('nutrition-selected');

                $('#grub-style').html($(this).attr('data-title'));

                setTimeout(() => {
                    $('body,html').animate(
                        { scrollTop: $('#protein-options').offset().top },
                        300
                    );
                }, 300);

                // :---- Protein
            } else if ($(this).hasClass('option-protein')) {
                $('.option-protein').removeClass('nutrition-selected');
                $(this).addClass('nutrition-selected');

                $('#grub-protein').html($(this).attr('data-title'));

                setTimeout(() => {
                    $('body,html').animate(
                        { scrollTop: $('#gusto-options').offset().top },
                        300
                    );
                }, 300);

                // :---- Gusto
            } else if ($(this).hasClass('option-gusto')) {
                $('.option-gusto').removeClass('nutrition-selected');
                $(this).addClass('nutrition-selected');

                $('#grub-gusto').html($(this).attr('data-title'));

                $('#grub-gusto').css({
                    background: $(this).attr('data-color')
                });

                setTimeout(() => {
                    $('body,html').animate(
                        { scrollTop: $('#nutrition-data').offset().top },
                        300
                    );
                }, 300);
            }

            const selectedItems = $('[data-calories].nutrition-selected');
            if (selectedItems.length < 3) {
                // not enough items selected
            } else {
                // Show the selected items
                $('.selected-summary').addClass('selected-summary--active');
                // We'll use this to calculate the ratio of sauce nutrition applied to totals
                const sauceRatio = parseFloat($('.option-style.nutrition-selected').first().attr('data-sauce-ratio'));
                // We'll use this title attribute to grab the sauce from the chosen gusto option
                const selectedGustoTitle = $('.option-gusto.nutrition-selected').first().attr('data-title');
                // Get the sauce that corresponds to the selected gusto
                const selectedGustoSauce = $('.option-sauce[data-title="'+selectedGustoTitle+'"]').first();
                // We need somewhere to store the calculated nutritional data
                const calculatedNutritionalData = {};
                
                // We'll loop through the selected items that have nutritional data to get their data and combine
                selectedItems.each((i, e) => {
                    // Let's get the nutritional data for this item
                    const itemData = $(e).data();

                    // We'll loop through the items data and check if the key exists in the object of calculated information, if so, we add to that value, if not, we create the key and add the value
                    for (const key of Object.keys(itemData)) {
                        if (calculatedNutritionalData.hasOwnProperty(key)) {
                            const currentValue = parseInt(
                                calculatedNutritionalData[key]
                            );
                            const newValue = Math.round(parseFloat(itemData[key]));
                            calculatedNutritionalData[key] =
                                currentValue + newValue;
                        } else {
                            calculatedNutritionalData[key] = Math.round(parseFloat(
                                itemData[key]
                            ));
                        }
                    }
                });

                // add sauce nutrition based on ratio
                selectedGustoSauce.each(function(i,e){
                    // Let's get the nutritional data for this item
                    const itemData = $(e).data();

                    // We'll loop through the items data and check if the key exists in the object of calculated information, if so, we add to that value based on the sauce ratio, if not, we create the key and add the value
                    for (const key of Object.keys(itemData)) {
                        if (calculatedNutritionalData.hasOwnProperty(key)) {
                            const currentValue = parseInt(
                                calculatedNutritionalData[key]
                            );
                            const newValue = Math.round(parseFloat(itemData[key]));
                            calculatedNutritionalData[key] =
                                currentValue + (newValue * sauceRatio);
                        } else {
                            calculatedNutritionalData[key] = Math.found(parseFloat(
                                calculatedNutritionalData[key]
                            ));
                        }
                    }
                });
                
                renderNutritionData(calculatedNutritionalData);


                // Determine whether combined selection meets dietary criteria
                // Variables for dietary attributes
                var vegan = true,
                    vegetarian = true,
                    dairyFree = true,
                    glutenFree = true;

                selectedItems.each(function(i,e){
                    var item = $(e);

                    if (item.attr('data-dietary-vegan') != "true") {
                        vegan = false;
                    }

                    if (item.attr('data-dietary-vegetarian') != "true") {
                        vegetarian = false;
                    }

                    if (item.attr('data-dietary-dairy-free') != "true") {
                        dairyFree = false;
                    }

                    if (item.attr('data-dietary-gluten-free') != "true") {
                        glutenFree = false;
                    }
                });
                renderDietaryLabels(vegan, vegetarian, dairyFree, glutenFree);
            }

            function renderNutritionData(nutritionData) {
                const source = document.getElementById('nutritionInfoTemplate')
                    .innerHTML;
                const template = Handlebars.compile(source);
                const html = template(nutritionData);
                $('.nutrition--data--content').html(html);
            }

            function renderDietaryLabels(vegan, vegetarian, dairyFree, glutenFree) {
                const labelContainer = $(".dietary-labels-summary");
                let dietaryLabelString = "";
                if (vegan) {
                    dietaryLabelString += '<span class="dietary-tag">vegan</span>';
                }
                if (vegetarian) {
                    dietaryLabelString += '<span class="dietary-tag">vegetarian</span>';
                }
                if (dairyFree) {
                    dietaryLabelString += '<span class="dietary-tag">dairy free</span>';
                }
                if (glutenFree) {
                    dietaryLabelString += '<span class="dietary-tag">gluten free</span>';
                }
                // Replace contents of summary element
                labelContainer.html(dietaryLabelString);
            }
        });
    },
    finalize() {}
};
